import type {TvmByAlias} from '../../types'
import {PRODUCTION} from './production'
import {TESTING} from './testing'

export const SERVICE = {
  production: PRODUCTION,
  testing: TESTING,
} as const satisfies TvmByAlias
